import { useForm } from '@inertiajs/vue3';
import { reactive, ref, watch } from 'vue';

import { locale } from '@/Localization.js';

export const offering = reactive({});
export const subscription = ref();
export const has_local_coupon = ref(null);
export const has_stripe_coupon = ref(null);
export const payment_label = ref(null);
export const payment_labels = ref(null);
export const route_submit = ref(null);

import { trans, transChoice } from 'laravel-vue-i18n';

export const emit = ref(null);
export const updateSubscription = (prop, value) => {
    // console.debug('CheckoutForm.updateSubscription()');
    emit.value('updateSubscription', prop, value)
};
export const reloadOffering = (code, callback) => {
    // console.debug('CheckoutForm.reloadOffering()');
    emit.value('reloadOffering', code, callback)
}

export const currentCoupon = ref({
    processing: false,
    code: '',
    status: 'none',
    duration: '',
});

let resultMsg = ref('');

export const form = useForm({
    partner: '',
    entitlement_id: '',
    entitlement_lookup_key: '',
    success_url: '',
    cancel_url: '',
    coupon: '',
});

export const currentCouponCode = ref(null);
const currentCouponCodeStripe = ref(null);
const setAppUserCoupon = () => {

    // console.debug('CouponForm.setAppUserCoupon()', {
    //     local: currentCouponCode.value,
    //     stripe: currentCouponCodeStripe.value,
    //     subscription: subscription.app_user_coupon_stripe
    // });

    //window.setCookie('app_user_coupon', currentCouponCode.value, 2629800 * 13);
    //window.setCookie('app_user_coupon_scope', /([0-9a-z-]+)/.exec(window.location.pathname)[1], 2629800 * 13);
    // 24h : le cookie ne sert qu'à survivre au tunnel (dont l'aller-retour du
    // login social sur mobile), pas à retenir le coupon sur le long terme.
    window.setCookie('app_user_coupon', currentCouponCode.value, 86400);
    // Le scope doit être le slug partenaire. L'ancienne regex sur le pathname
    // (/fr/orange-be/2) capturait la locale "fr", ce qui faisait échouer la
    // comparaison avec $partner_slug côté serveur (PartnersController) et la
    // restauration du coupon côté client (Welcome.vue).
    window.setCookie('app_user_coupon_scope', form.partner, 86400);

    updateSubscription('app_user_coupon', currentCouponCode ? currentCouponCode.value : '');
    updateSubscription('app_user_coupon_stripe', currentCouponCodeStripe
        ? currentCouponCodeStripe.value
        : subscription.app_user_coupon_stripe);
};

export const resetCoupon = () => {

    // console.debug('CouponForm.resetCoupon()', {
    //     local: currentCouponCode.value,
    //     stripe: currentCouponCodeStripe.value,
    //     subscription: subscription.app_user_coupon_stripe
    // })

    // form.cancel();

    currentCouponCode.value = '';
    currentCouponCodeStripe.value = '';
    updateSubscription('app_user_coupon', '');
    updateSubscription('app_user_coupon_stripe', null);
    updateSubscription('label', '');
    resultMsg.value = trans('Saisissez le coupon à valider.');
    currentCoupon.value = { processing: false, code: '', status: 'reset', duration: '' };
};

const stripeRequest = ref('{}');
const getStripeCouponInfos = (code) => {

    // console.debug('CouponForm.getStripeCouponInfos()', { code: code });

    return axios.post(route('xhr.stripe.coupons.check'), {
        partner: form.partner,
        coupon: code,
        subscription: subscription.value
    })
        .then(response => {
            const coupon = response.data;
            if (coupon && coupon.code) {

                let coupon_off = '~0';
                let price_normal = coupon.price ? coupon.price.unit_amount : null;
                let price_discount = 0;
                if (coupon.coupon.percent_off) {
                    coupon_off = `-${coupon.coupon.percent_off}\xa0%`;
                    price_discount = price_normal - (price_normal / 100 * coupon.coupon.percent_off);
                }
                if (coupon.coupon.amount_off) {
                    coupon_off = `-${number_format(coupon.coupon.amount_off / 100, 2, ',', ' ')}\xa0€`;
                    price_discount = price_normal - coupon.coupon.amount_off;
                }
                price_normal = number_format(price_normal / 100, 2, ',', ' ');
                price_discount = number_format(price_discount / 100, 2, ',', ' ');

                var duration = coupon.price && coupon.price.metadata
                    && typeof window.durations[coupon.price.metadata.duration] != 'undefined'
                    ? trans('durations.' + coupon.price.metadata.duration)
                    : null;

                if (!duration) {
                    // Wrong offer?
                    // console.error('duration is missing! (1)', coupon.price, window.durations);

                    // Test
                    // if (price.stripe['type'] == 'recurring') {
                    //     duration = priceRecurringIntervalToFr(price.stripe['recurring']['interval_count'], price.stripe['recurring']['interval'], true);
                    // }
                }

                // => Ce coupon permet une réduction de ${percent_off} %
                // => Profitez du forfait ${duration} à ${percent_off}, soit {price_discount} € au lieu de {price} €
                var message = trans(payment_label.value);
                if (payment_labels.value && Object.keys(payment_labels.value).length) {
                    var message_new = '';
                    var is_recurring = offering.value.packages.items[0].products.items[0].stripe.recurring;
                    if (parseFloat(price_discount) > 0) {
                        if (is_recurring) {
                            message_new = payment_labels.value['subscription_with_coupon'];
                        } else {
                            message_new = payment_labels.value['one_time_with_coupon'];
                        }
                    } else {
                        if (is_recurring) {
                            message_new = payment_labels.value['subscription'];
                        } else {
                            message_new = payment_labels.value['one_time'];
                        }
                    }

                    if (message_new) {
                        console.error('message_new?', { message_new: message_new, trans: trans(message_new) })
                        message_new = trans(message_new);
                        message = message_new;
                    }

                    // console.error("is_recurring:", {
                    //     is_recurring: is_recurring,
                    //     price_discount: price_discount,
                    //     message: message,
                    //     message_new: message_new,
                    //     payment_labels: payment_labels.value,
                    // })

                    // console.debug('payment_labels?', message_new, {
                    //     price_normal: parseFloat(price_normal),
                    //     price_discount: parseFloat(price_discount),
                    //     is_recurring: is_recurring
                    // });
                }

                message = message.replace(/\$\{duration\}/, duration);
                message = message.replace(/\$\{coupon_off\}/, coupon_off);
                message = message.replace(/\$\{price_discount\}/, price_discount);
                message = message.replace(/\$\{price\}/, price_normal);

                message = message.replace(/:duration/, duration);
                message = message.replace(/:coupon_off/, coupon_off);
                message = message.replace(/:price_discount/, price_discount);
                message = message.replace(/:price/, price_normal);

                // console.error('message?', {
                //     message: message,
                //     message_new: message_new,
                //     payment_label: payment_label.value,
                //     payment_labels: payment_labels.value
                // });

                currentCouponCode.value = coupon.code;
                currentCouponCodeStripe.value = coupon;

                // console.debug('Stripe coupon is:', code, coupon);
                // console.debug('NEW LABEL:', message, coupon.price);

                if (duration && price_normal) {
                    // console.debug('NEW LABEL:', message);
                    updateSubscription('label', message);
                    resultMsg.value = `<div class="text-green-700 dark:text-green-300">${message}</div>`;
                }

                setAppUserCoupon();
            }
            else {
                console.error('Coupon failed?');
            }

            return coupon;
        })
        .catch(error => {
            console.error('error')

            const data = error && error.response
                ? error.response.data
                : null;
            if (data && data.errors) {

                currentCouponCode.value = '';
                currentCouponCodeStripe.value = '';
                setAppUserCoupon();

                // form.setError('field', 'Your error message.');
                form.errors[Object.keys(data.errors)[0]] = true;
            }
        });
};

const getLocalCouponInfos = async (code) => {
    currentCoupon.value.processing = true;

    return axios.post(route('xhr.coupons.check', { coupon: code }), {
        partner: form.partner,
        entitlement_id: form.entitlement_id,
        entitlement_lookup_key: form.entitlement_lookup_key
    })
        .then(response => {

            // console.debug('CouponForm.getLocalCouponInfos()', code, response.data);

            currentCouponCode.value = code;
            currentCouponCodeStripe.value = '';

            // console.debug('NEW LABEL:', response.data.message);
            updateSubscription('label', response.data.message);

            currentCoupon.value = {
                processing: false,
                code: code,
                status: response.data
                    && response.data.current
                    && response.data.current.used == false ? 'success' : 'failed',
                duration: response.data.current_duration,
            };

            if (response.data.message) {
                resultMsg.value = `<div class="text-green-700 dark:text-green-300">${response.data.message}</div>`;
            }

            setAppUserCoupon();
        })
        .catch(error => {
            console.error('error', error)

            currentCoupon.value.processing = false;

            const data = error && error.response
                ? error.response.data
                : null;
            if (data && data.errors) {
                for (var z in data.errors) {
                    form.errors[z] = data.errors[z][0];
                }
            }

            return error;
        });
};

const getLocalCoupon = (code) => {

    // console.debug('CouponForm.getLocalCoupon()', code);

    // We check this route a first time to test its validity.
    form.post(route('xhr.coupons.check', { coupon: code }), {
        onSuccess: (response) => {
            // We check this route a second time for coupon information.
            // getLocalCouponInfos(code);
        },
        onError: (e) => {
            console.error('onError', e)
            currentCouponCode.value = '';
            currentCouponCodeStripe.value = '';
            window.setCookie('app_user_coupon', null, -1);
            window.setCookie('app_user_coupon_scope', null, -1);
            resetCoupon();
        },
    });
};

// Pre-Check coupon to recalculate offering from promotional.
export const preCheckCoupon = () => {

    // console.debug('CouponForm.preCheckCoupon()', { code: form.coupon });

    var local_coupon = !has_stripe_coupon.value && has_local_coupon.value && !!form.coupon; // debug

    if (local_coupon) {

        // console.error('local_coupon',
        //     {
        //         local_coupon: local_coupon,
        //         has_stripe_coupon: !has_stripe_coupon.value,
        //         has_local_coupon: has_local_coupon.value,
        //         code: !!form.coupon
        //     })

        // return getLocalCoupon(form.coupon);
        return checkCoupon();
    }

    form.clearErrors();

    if (!form.coupon) {
        return false;
    }

    resetCoupon();

    currentCoupon.value.processing = true;

    axios.post(route('xhr.stripe.coupons.check'), {
        partner: form.partner,
        coupon: form.coupon,
        subscription: subscription.value
    })
        .then(response => {
            // console.debug('CouponForm.preCheckCoupon()', response.data);

            var price_exists_in_offering = false;

            currentCoupon.value.processing = false;

            if (response.data.promotional
                && response.data.promotional.default_price) {

                // Skip reloadOffering() if promotional.default_price (price_1NsiF5BdMgw5OUUd1Y7o7ov1) already exists in "offering". 
                // response.data.promotional.default_price = 'price_1NsiF5BdMgw5OUUd1Y7o7ov1';
                bloc_externe: for (var item of offering.value.packages.items) {
                    for (var item2 of item.products.items) {
                        // item2 false price_1ONHYKBdMgw5OUUdx45qwviG price_1NsiF5BdMgw5OUUd1Y7o7ov1

                        // console.debug('item2',
                        //     item2.stripe.id == response.data.promotional.default_price.id,
                        //     JSON.parse(JSON.stringify(item2.stripe.id)),
                        //     response.data.promotional.default_price.id);

                        if (item2.stripe.id == response.data.promotional.default_price.id) {
                            price_exists_in_offering = true;
                            // console.debug('"promotional.default_price" exists in offering!');
                            break bloc_externe;
                        }
                    }
                }

                currentCouponCode.value = form.coupon;
                setAppUserCoupon();
            }

            if (price_exists_in_offering) {
                return checkCoupon();
            } else {
                return reloadOffering(form.coupon, checkCoupon);
            }

        })
        .catch(error => {
            if (error.response) {
                const data = error.response.data;

                // console.error('axios.error', JSON.parse(JSON.stringify(data.errors)), Object.keys(data.errors)[0]);

                currentCoupon.value.processing = false;
                if (typeof data.errors == 'object'
                    && Object.keys(data.errors).length) {
                    form.errors[Object.keys(data.errors)[0]] = 'true';
                }
            } else {
                // return checkCoupon();
                return reloadOffering(form.coupon, checkCoupon);
            }
        });
}

// Check if there is a local/stripe coupon.
export const checkCoupon = async () => {

    // console.debug('CouponForm.checkCoupon()', { code: form.coupon });

    resultMsg.value = trans(`Vérification du coupon...`);

    var code = form.coupon;
    code = code ? code : 'null';

    form.clearErrors();

    if (!code || code == 'null') {
        resetCoupon();

        return false;
    }

    // var force_stripe_code = false; // debug
    var force_stripe_code = !has_stripe_coupon.value && !has_local_coupon.value && !!code; // debug

    if ((!has_stripe_coupon.value
        && !has_local_coupon.value)
        && !force_stripe_code) {

        console.error('CouponForm.checkCoupon()', {
            code: code,
            has_stripe_coupon: has_stripe_coupon.value,
            has_local_coupon: has_local_coupon.value,
            'stripeRequest.id': stripeRequest && stripeRequest.value ? stripeRequest.value.id : null
        });

        return false;
    }

    if (has_stripe_coupon.value || force_stripe_code) {
        currentCoupon.value.processing = true;
        stripeRequest.value = await getStripeCouponInfos(code);
        currentCoupon.value.processing = false;
    }

    if (has_local_coupon.value && !stripeRequest.value.id) {
        try {
            var infos = await getLocalCouponInfos(code);
        } catch (err) {
            currentCoupon.value.processing = false;
            const data = err.response.data;
            if (typeof data.errors == 'object'
                && Object.keys(data.errors).length
                && Object.keys(data.errors).length > 1) {
                form.errors[Object.keys(data.errors)[1]] = 'true';
            } else {
                getLocalCoupon(code);
            }
        }
    }

    // if (Object.keys(form.errors).length) {
    //     console.debug('form.errors:', JSON.parse(JSON.stringify(form.errors)));
    // }

    return false;
};

export const submit = () => {

    // console.debug('CouponForm.submit()', {
    //     route_submit: route_submit.value,
    //     entitlement_id: form.entitlement_id
    // });

    if (!form.entitlement_id) {
        console.warn('entitlement_id not loaded!');

        return false;
    }

    form.clearErrors();

    // Note: Partenamut has a Stripe coupon. 
    // So there is no "route_coupon_validate" to check/validate 
    // this type of coupon.
    if (route_submit.value) {

        if (!has_stripe_coupon.value && !has_local_coupon.value) {
            // console.debug('no coupon', {
            //     route_submit: route_submit.value,
            //     has_stripe_coupon: has_stripe_coupon.value,
            //     has_local_coupon: has_local_coupon.value
            // });

            return false;
        }

        // console.debug('route_submit', route(route_submit.value, { 'locale': locale.value, 'partner_slug': form.partner }))

        form.post(route(route_submit.value, { 'locale': locale.value, 'partner_slug': form.partner }), {
            onFinish: (response) => {
                // console.debug('response', response);
            }
        });
    } else {
        console.error('route_submit.value?')
    }
};

watch(() => form.coupon,
    (val, oldVal) => {
        if (form.coupon != currentCouponCode.value) {
            currentCouponCode.value = '';
        }
        if (form.coupon != currentCouponCodeStripe.value) {
            currentCouponCodeStripe.value = '';
        }
    }
);
